(function () {
  if (window.AxiomVariantForm) return;

  function getStateMap(state) {
    if (!state) return {};
    return state.variants || state;
  }

  function getVariantState(variant, state) {
    if (!variant) return null;
    return getStateMap(state)[String(variant.id)] || null;
  }

  function getQuantityRule(variant, state) {
    var variantState = getVariantState(variant, state);
    var rule = variantState && variantState.quantityRule ? variantState.quantityRule : (variant && (variant.quantity_rule || variant.quantityRule)) || {};
    return {
      min: Math.max(1, parseInt(rule.min || 1, 10) || 1),
      max: rule.max === null || rule.max === undefined || rule.max === '' ? null : parseInt(rule.max, 10),
      increment: Math.max(1, parseInt(rule.increment || 1, 10) || 1)
    };
  }

  function shouldCheckInventory(variant, state) {
    var variantState = getVariantState(variant, state);
    var inventoryManagement = variantState && variantState.inventoryManagement !== undefined
      ? variantState.inventoryManagement
      : variant && variant.inventory_management;
    var inventoryPolicy = variantState && variantState.inventoryPolicy !== undefined
      ? variantState.inventoryPolicy
      : variant && variant.inventory_policy;
    return inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
  }

  function getInventoryQuantity(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && variantState.inventoryQuantity !== undefined && variantState.inventoryQuantity !== null) {
      return parseInt(variantState.inventoryQuantity, 10) || 0;
    }
    return parseInt((variant && variant.inventory_quantity) || 0, 10) || 0;
  }

  function variantRequiresSellingPlan(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && variantState.requiresSellingPlan !== undefined) {
      return Boolean(variantState.requiresSellingPlan);
    }
    return Boolean(variant && variant.requires_selling_plan);
  }

  function getSellingPlanAllocations(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && Array.isArray(variantState.sellingPlanAllocations)) {
      return variantState.sellingPlanAllocations;
    }
    if (variant && Array.isArray(variant.selling_plan_allocations)) {
      return variant.selling_plan_allocations;
    }
    return [];
  }

  function getSellingPlanAllocationById(variant, state, sellingPlanId) {
    if (!sellingPlanId) return null;
    return getSellingPlanAllocations(variant, state).find(function (allocation) {
      return String(allocation.sellingPlanId || allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id) || '') === String(sellingPlanId);
    }) || null;
  }

  function getFirstSellingPlanAllocation(variant, state) {
    var allocations = getSellingPlanAllocations(variant, state);
    return allocations.length ? allocations[0] : null;
  }

  function isSoldOut(variant, state) {
    var variantState = getVariantState(variant, state);
    var available = variantState && variantState.available !== undefined ? variantState.available : variant && variant.available;
    if (!variant || !available) return true;
    return shouldCheckInventory(variant, state)
      && getInventoryQuantity(variant, state) < getQuantityRule(variant, state).min;
  }

  function findAvailableVariantForOptionValue(product, selected, position, value, state) {
    var optionPosition = parseInt(position, 10);
    if (!product || !Array.isArray(product.variants) || !optionPosition) return null;
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (options[optionPosition - 1] !== value || isSoldOut(variant, state)) return false;
      for (var index = 0; index < optionPosition - 1; index += 1) {
        var selectedValue = selected && selected[index + 1];
        if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '' && options[index] !== selectedValue) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  function isOptionValueAvailable(product, selected, position, value, state) {
    return Boolean(findAvailableVariantForOptionValue(product, selected, position, value, state));
  }

  function getEffectiveMaxQty(variant, state) {
    var quantityRule = getQuantityRule(variant, state);
    var variantState = getVariantState(variant, state);
    var cartQuantity = Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
    var totalMax = quantityRule.max;
    if (shouldCheckInventory(variant, state)) {
      var inventoryMax = getInventoryQuantity(variant, state);
      totalMax = totalMax === null ? inventoryMax : Math.min(totalMax, inventoryMax);
    }
    return totalMax === null ? null : Math.max(0, totalMax - cartQuantity);
  }

  function getMinimumAddQty(variant, state) {
    var rule = getQuantityRule(variant, state);
    var variantState = getVariantState(variant, state);
    var cartQuantity = Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
    return cartQuantity >= rule.min ? rule.increment : rule.min;
  }

  function syncCartQuantity(variant, state, cart) {
    var variantState = getVariantState(variant, state);
    if (!variantState || !cart || !window.AxiomStandardStorefront) return;
    var lines = window.AxiomStandardStorefront.getCartLines(cart);
    variantState.cartQuantity = lines.reduce(function (total, line) {
      var id = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      return String(id).split('/').pop() === String(variant.id)
        ? total + (parseInt(line.quantity, 10) || 0)
        : total;
    }, 0);
  }

  function normalizeQty(rawValue, variant, state, allowZero) {
    var quantityRule = getQuantityRule(variant, state);
    var min = getMinimumAddQty(variant, state);
    var increment = quantityRule.increment;
    var max = getEffectiveMaxQty(variant, state);
    if (max !== null && max < min) return 0;
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : min;
    if (allowZero && value <= 0) return 0;
    if (value < min) value = min;
    if (value > min) {
      var remainder = (value - min) % increment;
      if (remainder !== 0) value -= remainder;
    }
    if (max !== null && value > max) {
      value = max;
      if (value >= min) value -= (value - min) % increment;
    }
    if (!allowZero && value < min) value = min;
    return Math.max(allowZero ? 0 : min, value);
  }

  function selectedOptions(root, buttonSelector) {
    var selected = {};
    if (!root || !buttonSelector) return selected;
    root.querySelectorAll(buttonSelector + '.active').forEach(function (button) {
      selected[parseInt(button.dataset.optionPosition, 10)] = button.dataset.value;
    });
    return selected;
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    });
  }

  function findVariant(product, selected) {
    if (!product || !product.variants) return null;
    if (product.variants.length === 1 && Object.keys(selected || {}).length === 0) {
      return product.variants[0];
    }
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (!options.length) return false;
      return options.every(function (value, index) {
        return selected[index + 1] === value;
      });
    }) || null;
  }

  function syncQuantityControls(options) {
    var root = options.root || document;
    var variant = options.variant;
    var state = options.state;
    var qtyInput = root.querySelector(options.inputSelector);
    var qtyValue = root.querySelector(options.valueSelector);
    var minus = root.querySelector(options.minusSelector);
    var plus = root.querySelector(options.plusSelector);
    if (!qtyInput || !qtyValue || !variant) return 0;

    var quantityRule = getQuantityRule(variant, state);
    var soldOut = isSoldOut(variant, state);
    var max = getEffectiveMaxQty(variant, state);
    var min = getMinimumAddQty(variant, state);
    var unavailable = soldOut || (max !== null && max < min);
    var nextQty = unavailable ? 0 : normalizeQty(options.keepCurrentValue ? qtyInput.value : min, variant, state, false);

    qtyInput.value = nextQty;
    qtyValue.textContent = nextQty;
    qtyInput.min = min;
    qtyInput.step = quantityRule.increment;
    if (max !== null) qtyInput.max = max;
    else qtyInput.removeAttribute('max');

    if (minus) minus.disabled = unavailable || nextQty <= min;
    if (plus) plus.disabled = unavailable || (max !== null && nextQty >= max);
    if (typeof options.onChange === 'function') options.onChange(variant, nextQty);
    return nextQty;
  }

  function collectProperties(form) {
    var properties = {};
    if (!form) return properties;
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (!match) return;
      if (value === '' || value === null || value === undefined) return;
      if (typeof File !== 'undefined' && value instanceof File) return;
      properties[match[1]] = value;
    });
    return properties;
  }

  function formHasFiles(form) {
    if (!form || !form.querySelectorAll) return false;
    return Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (input) {
      return input.files && input.files.length;
    });
  }

  window.AxiomVariantForm = {
    getVariantState: getVariantState,
    getQuantityRule: getQuantityRule,
    shouldCheckInventory: shouldCheckInventory,
    getInventoryQuantity: getInventoryQuantity,
    variantRequiresSellingPlan: variantRequiresSellingPlan,
    getSellingPlanAllocations: getSellingPlanAllocations,
    getSellingPlanAllocationById: getSellingPlanAllocationById,
    getFirstSellingPlanAllocation: getFirstSellingPlanAllocation,
    isSoldOut: isSoldOut,
    getEffectiveMaxQty: getEffectiveMaxQty,
    getMinimumAddQty: getMinimumAddQty,
    syncCartQuantity: syncCartQuantity,
    normalizeQty: normalizeQty,
    selectedOptions: selectedOptions,
    getVariantOptions: getVariantOptions,
    findVariant: findVariant,
    findAvailableVariantForOptionValue: findAvailableVariantForOptionValue,
    isOptionValueAvailable: isOptionValueAvailable,
    syncQuantityControls: syncQuantityControls,
    collectProperties: collectProperties,
    formHasFiles: formHasFiles
  };
})();
